angular.module('jv.services')
.factory('jvInterviewService', ['$localStorage', '$sessionStorage', '$window',
    function ($localStorage, $sessionStorage, $window) {
    return {
        interviewSelection: {},
        candTimeslots: 1,
        schedulerSlots: {},
        interviewers: [],
        requestAvailabilityRestoreState: null,
        includeConferenceLink: false,
        videoConferenceEnabled: false,
        baseDuration: [
            {text: '15 min', id: '15', value: 15},
            {text: '30 min', id: '30', value: 30},
            {text: '45 min', id: '45', value: 45},
            {text: '60 min', id: '60', value: 60},
            {text: '75 min', id: '75', value: 75},
            {text: '90 min', id: '90', value: 90},
            {text: '105 min', id: '105', value: 105},
            {text: '2 hr', id: '120', value: 120},
            {text: '3 hr', id: '180', value: 180},
            {text: '4 hr', id: '240', value: 240},
            {text: '5 hr', id: '300', value: 300},
            {text: '6 hr', id: '360', value: 360},
            {text: '7 hr', id: '420', value: 420},
            {text: '8 hr', id: '480', value: 480}
        ],
        initInterviewCache: function() {
            var interviewCache = {
                keys : [],
                items : {},
                expires : {},
                size : 0,
                maxsize : 50
            };
            $localStorage.interviewCache = interviewCache;
            return interviewCache;
        },
        getBaseDuration: function() {
            return this.baseDuration;
        },
        saveRequestAvailabilityRestoreState: function(requestAvailabilityRestoreState){
            this.requestAvailabilityRestoreState = requestAvailabilityRestoreState;
        },
        getRequestAvailabilityRestoreState: function(){
            return this.requestAvailabilityRestoreState;
        },
        clearRequestAvailabilityRestoreState: function(){
           this.requestAvailabilityRestoreState = null;
        },
        saveSchedulerSlots: function(slots){
            this.schedulerSlots = slots;
        },
        getSchedulerSlots: function(){
            return this.schedulerSlots;
        },
        saveInterviewers: function(interviewers){
            this.interviewers = interviewers;
        },
        getInterviewers: function(){
            return this.interviewers;
        },
        saveCandTimeslots: function(timeslot){
            $sessionStorage.candTimeslots = timeslot;
        },
        getCandTimeslots: function(){
            return $sessionStorage.candTimeslots;
        },
        saveInterviewSelection: function(requisitionId, csId, interviews, meetingRooms, timezone) {
            var interviewSelection = {
                key: requisitionId + '-' + csId,
                interviews: interviews,
                meetingRooms: meetingRooms,
                timezone: timezone
            };
            $sessionStorage.interviewSelection = interviewSelection;
        },
        getInterviewSelection: function(requisitionId, csId) {
            var key = requisitionId + '-' + csId;
            if ($localStorage.interviewCache) {
                var interviewCache = $localStorage.interviewCache;
                var item = angular.copy(interviewCache.items[key]);
                if (item) {
                    interviewCache.expires[key] = Date.now();
                    $localStorage.interviewCache = interviewCache;
                    return item;
                }
            }
            return null;
        },
        getSessionInterviewSelection: function() {
            return $sessionStorage.interviewSelection;
        },

        deleteSessionInterviewSelection: function() {
            delete $sessionStorage.interviewSelection;
        },
        cacheInterviewSelection: function() {
            var interviewCache = $localStorage.interviewCache;
            if (angular.isUndefined(interviewCache)) {
                interviewCache = this.initInterviewCache();
            }

            var keys = interviewCache.keys,
                items = interviewCache.items,
                expires = interviewCache.expires,
                size = interviewCache.size,
                maxsize = interviewCache.maxsize,
                key = $sessionStorage.interviewSelection.key;

            if (size >= maxsize) {
                keys.sort(function(a,b) {
                    if (expires[a] > expires[b]) {return -1;}
                    if (expires[a] < expires[b]) {return 1;}
                    return 0;
                });

                size--;
                delete expires[keys[size]];
                delete items[keys[size]];
            }

            if (keys.indexOf(key) == -1) {
                keys[size] = key;
                items[key] = $sessionStorage.interviewSelection;
                expires[key] = Date.now();
                size++;
            } else {
                items[key] = $sessionStorage.interviewSelection;
                expires[key] = Date.now();
            }

            interviewCache.keys = keys;
            interviewCache.items = items;
            interviewCache.expires = expires;
            interviewCache.size = size;
            interviewCache.maxsize = maxsize;

            $localStorage.interviewCache = interviewCache;

            this.deleteSessionInterviewSelection();
        },
        saveIncludeConferenceLink: function(value) {
            this.includeConferenceLink = value;
        },
        getIncludeConferenceLink: function() {
            return this.includeConferenceLink;
        },
        saveVideoConferenceEnabled: function(value) {
            this.videoConferenceEnabled = value;
        },
        getVideoConferenceEnabled: function() {
            return this.videoConferenceEnabled;
        },
        getPhoneNoList: function() {
            return this.getPhoneNoList;
        }
    };
}])
.service('candidates', ['$http', '$sessionStorage', 'TextUtil', 'makeAjaxCall', '$q', '$log',
    function($http, $sessionStorage, TextUtil, makeAjaxCall, $q, $log){

    var jvUrls = window.jvUrls;
    var candidateDetailsURL = '../../action/applicationDetails',
    reqDetailsURL = '../../action/requisitionDetails',
    resourceDetails = '../../action/resource',
    adminUrl = jvUrls.admin+'/action/admin',
    adminActionUrl = jvUrls.admin + '/action',
    applicationDetails = jvUrls.jhire +'/action/application',
    applicationList = '../../action/applications',
    saveTaskUrl = jvUrls.source + '/action/task/save',
    calendarUrl = jvUrls.jhire + '/action/calendar',
    userInfoUrl = jvUrls.admin + '/action/user',
    interviewUrl = jvUrls.jhire + '/action/interview',
    reqListRestBaseUrl = jvUrls.jhire + '/action/requisitions',
    videoConferencingUrl = jvUrls.jhire + '/action/videoConferencing',
    phoneListUrl = jvUrls.jhire + '/action/application/sendSMSMessage/phoneList',
    quickViews = {};
    var countries = {};


    var userTimezoneObj = null;

    function createRequestObject(args, callback, options, onError) {
        var _args = {
            headers : {
                'Content-Type': 'application/json; charset=UTF-8'
            }
        };
        callback = (callback || angular.noop);
        var requestObj = args || _args;
        requestObj.ajaxtype = options.ajaxtype;
        requestObj.url = options.url;
        requestObj.requestType = options.requestType || 'GET';
        requestObj.cache = options.cache || false;
        var requestPromise = makeAjaxCall(requestObj);
        requestPromise.then(function(results) {
            countries = options.ajaxtype === 'getCountries' ?  angular.copy(results.data) : {};
            callback(results.data, results.status);
        }, function(error){
            if(onError){
                onError(error);
            }
        });
    }

    /**
     * Pagination
     */
    var paging = {
        list: [],
        index: false,
        cache: {}
    };

    // Depricated not getting reffered
    this.paging = function(applicationId, callback) {
        return $http({
            url: jvUrls.source + '/action/person/applicantList?action=getCandidateDetailsView&ids=' + applicationId,
            method: 'GET'
        }).success(function(response){
            if (response.viewcandidaterequest) {
                paging.count = response.viewcandidaterequest.totalCount;
                paging.list = response.viewcandidaterequest.applicationids;
                paging.index = response.viewcandidaterequest.applicationids.indexOf(applicationId);
                paging.cache = {};
                callback(paging);
            }
        });
    };
    //make call to get application ids for pagination coming from new candidate profile list page.
    this.getPaginationIds = function(applicationId, index, guid, page, callback) {
        var postData = {
            filterId: guid,
            index: index,
            page: page
        };
        var url = jvUrls.jhire + '/action/candidates/pagination';
        var ajaxOptions = {
            'ajaxtype': 'getPaginationIds',
            'url': url,
            'requestType': 'POST'
        };
        postData.headers = {'Content-Type':'application/json; charset=UTF-8'};
        createRequestObject(postData, callback, ajaxOptions);
    };

    // new application search pagination
    this.getApplicationPaginationIds = function(applicationId, search) {
        return $http.post(jvUrls.jhire + '/action/application/pagination', search).then(function(response) {
            var data = response.data;
            var list = data.applicationSearchResults.map(function(item) {
                return item.EId;
            });
            var index = list.indexOf(applicationId);
            $sessionStorage.search_application_ids = list;
            $sessionStorage.search_total_count = data.totalCount;
            $sessionStorage.search_index = index;
            return {
                count: data.totalCount,
                list: list,
                index: index
            };
        }, function(error){
            $log.error(error);
        });
    };

    this.getSeekConsentTemplate = function(applicationId, callback, fail){
        var url = applicationDetails + '/' + applicationId+'/seekConsent';
        var ajaxOptions = {
            'ajaxtype': 'getSeekConsentTemplate' ,
            'url': url
        };
        createRequestObject(null, callback, ajaxOptions, fail);
    };

    this.sendSeekConsentMessage = function(applicationId, postData, callback, fail){
        var url = applicationDetails + '/' + applicationId+'/seekConsent';
        var ajaxOptions = {
            'ajaxtype': 'sendSeekConsentMessage',
            'url': url,
            'requestType': 'POST'
        };
        postData.headers = {'Content-Type':'application/json; charset=UTF-8'};
        createRequestObject(postData, callback, ajaxOptions,fail);
    };

    this.getRequestAvailabilityTemplate = function(jobEId, stateEId, params, callback, fail){
        var ajaxOptions = {
            'ajaxtype': 'gCalEventsResource' ,
            'url': interviewUrl + '/' + jobEId + '/' + stateEId + '/requestAvailability'
        };

        createRequestObject(params, callback, ajaxOptions, fail);
    };

    this.checkInterviewersVideoConferencingAccount = function(applicationId, params, callback, fail){
        var ajaxOptions = {
            'ajaxtype': 'checkInterviewersVideoConferencingAccount' ,
            'url': videoConferencingUrl + '/usersExist'
        };

        createRequestObject(params, callback, ajaxOptions, fail);
    };

    this.getScheduleInterviewTemplate = function(applicationEId, stateEId, params, callback, fail){
        var data = {
            params: params
        };
        $http.get(interviewUrl + '/' + applicationEId + '/' + stateEId + '/scheduleTemplates', data).success(callback).error(fail);
    };

    /**
     * REMOVE GENERATED OFFER LETTER
     */
    this.removeGenOfferLetter = function(applicationId, callback){
        var url = applicationDetails + '/' + applicationId+'/offerLetter';
        var ajaxOptions = {
            'ajaxtype': 'removeGenOfferLetter',
            'url': url,
            'requestType': 'DELETE'
        };
        createRequestObject(null, callback, ajaxOptions);
    };

    /*
     * Evaluations of a user
     */
    // Depricated not getting reffered
    this.getUserEvaluations = function(applicationId, userId, fastRead, callback, fail){
        $http.get(applicationDetails + '/' + applicationId+'/user/'+userId+'/evaluations?readMode='+(fastRead || 1)).success(callback).error(fail);
    };

    /*
     * Evaluations of a user of a state
     */
    // Depricated not getting reffered
    this.getUserStateEvaluations = function(applicationId, userId, stateId, fastRead, callback, fail){
        $http.get(applicationDetails + '/' + applicationId+'/user/'+userId+'/state/'+stateId+'/evaluations?readMode='+(fastRead || 1)).success(callback).error(fail);
    };

    /*
     * Evaluations of a state
     */
    this.getEvaluations = function(applicationId, stateId, interviewId, fastRead, callback, fail){
        var val;
        fastRead ? val = 0 : val = 1;
        var url  = applicationDetails + '/' + applicationId+'/workflowState/'+stateId+'/evaluations?readMode='+val;
        if(interviewId){
           url += '&interviewEId='+interviewId;
        }
        var ajaxOptions = {
            'ajaxtype': 'getEvaluations' ,
            'url': url
        };
        createRequestObject(null, callback, ajaxOptions, fail);
    };

    this.getAllEvaluations = function(applicationId, fastRead, callback, fail){
        var val;
        fastRead ? val = 0 : val = 1;
        var url = applicationDetails + '/' + applicationId+'/interviewEvaluations?readMode='+val;
        var ajaxOptions = {
            'ajaxtype': 'getAllEvaluations' ,
            'url': url
        };
        createRequestObject(null, callback, ajaxOptions, fail);
    };

    this.submitEvaluation = function(applicationId, stateId, interviewEId, data, callback, fail){
        if(!interviewEId || interviewEId === 'undefined'){
            interviewEId = 0;
        }
        var url = applicationDetails + '/' + applicationId+'/workflowState/'+stateId+'/interview/'+interviewEId+'/evaluation';
        var ajaxOptions = {
            'ajaxtype': 'submitEvaluation',
            'url': url,
            'requestType': 'POST'
        };
        data.headers = {'Content-Type':'application/json; charset=UTF-8'};
        createRequestObject(data, callback, ajaxOptions,fail);
    };

    this.getEvaluationForSubmit = function(applicationId, stateId, interviewEId, readMode, callback, fail){
        if(!interviewEId || interviewEId === 'undefined'){
            interviewEId = 0;
        }
        var rm;
        readMode ? rm = 0 : rm = 1;
        var url = applicationDetails + '/' + applicationId+'/workflowState/'+stateId+'/interview/'+interviewEId+'/evaluation?readMode='+rm;
        var ajaxOptions = {
            'ajaxtype': 'getEvaluationForSubmit' ,
            'url': url
        };
        createRequestObject(null, callback, ajaxOptions, fail);
    };

    this.postEvalForwardTmpl = function(applicationId, stateId, data, callback, fail){
        var url = applicationDetails + '/' + applicationId+'/workflowState/'+stateId+'/forwardEvaluation';
        var ajaxOptions = {
            'ajaxtype': 'postEvalForwardTmpl',
            'url': url,
            'requestType': 'POST'
        };
        data.headers = {'Content-Type':'application/json; charset=UTF-8'};
        createRequestObject(data, callback, ajaxOptions,fail);
    };

    this.getEvalForwardTmpl = function(applicationId, stateId, callback, fail){
        var url = applicationDetails + '/' + applicationId+'/workflowState/'+stateId+'/forwardEvaluation';
        var ajaxOptions = {
            'ajaxtype': 'getEvalForwardTmpl',
            'url': url
        };
        createRequestObject(null, callback, ajaxOptions, fail);
    };

    this.postEvalRequestMoreDetails = function(applicationId, stateId, interviewId, userId, data, callback, fail){
        var url = applicationDetails + '/' + applicationId+'/workflowState/'+stateId+'/interview/'+interviewId+'/recipientId/'+userId+'/evaluationRequestMoreDetails';
        var ajaxOptions = {
            'ajaxtype': 'postEvalRequestMoreDetails',
            'url': url,
            'requestType': 'POST'
        };
        data.headers = {'Content-Type':'application/json; charset=UTF-8'};
        createRequestObject(data, callback, ajaxOptions,fail);
    };

    this.getEvalRequestMoreDetails = function(applicationId, stateId, interviewId, userId, callback, fail){
        var url = applicationDetails + '/' + applicationId+'/workflowState/'+stateId+'/interview/'+interviewId+'/recipientId/'+userId+'/evaluationRequestMoreDetails';
        var ajaxOptions = {
            'ajaxtype': 'getEvalRequestMoreDetails',
            'url': url
        };
        createRequestObject(null, callback, ajaxOptions, fail);
    };

    this.postEvaluationReminder = function(applicationId, stateId, data, callback, fail){
        var url = applicationDetails + '/' + applicationId+'/workflowState/'+stateId+'/evaluationReminder';
        var ajaxOptions = {
            'ajaxtype': 'postEvaluationReminder',
            'url': url,
            'requestType': 'POST'
        };
        data.headers = {'Content-Type':'application/json; charset=UTF-8'};
        createRequestObject(data, callback, ajaxOptions,fail);
    };

    this.getEvaluationReminderTempl = function(applicationId, stateId, callback, fail){
        var url = applicationDetails + '/' + applicationId+'/workflowState/'+stateId+'/evaluationReminder';
        var ajaxOptions = {
            'ajaxtype': 'getEvaluationReminderTempl' ,
            'url': url
        };
        createRequestObject(null, callback, ajaxOptions, fail);
    };

    // Depricated not getting reffered anywhere
    this.getEvalPermission = function(applicationId, stateId, callback){
        $http.get(userInfoUrl + '/views/' + applicationId+'/'+ stateId).success(callback);
    };

    // Depricated not getting reffered anywhere
    this.getCandidateDetails = function(applicationId, data, callback,fail){
        $http.get(applicationDetails + '/' + applicationId + '/candidateDetails?'+data).success(callback).error(fail);
    };

    this.postDisposition = function(id, data, callback, fail){
        var url = applicationDetails+'/'+id+'/disposition';
        var ajaxOptions = {
            'ajaxtype': 'postDisposition',
            'url': url,
            'requestType': 'POST'
        };
        data.headers = {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'};
        createRequestObject(data, callback, ajaxOptions,fail);
    };

    this.getCountries = function(callback, fail){
        if(!countries.resultList){
            var url = jvUrls.source+'/action/sys/countries';
            var ajaxOptions = {
                'ajaxtype': 'getCountries' ,
                'url': url
            };
            createRequestObject(null, callback, ajaxOptions, fail);
        }else{
            callback(countries);
        }
    };

    // Depricated not getting reffered anywhere
    this.getAddCandFields = function(callback, fail){
        $http.get(applicationDetails+'/addCandidate').success(callback).error(fail);
    };
    // Depricated not getting reffered anywhere
    this.getResource = function(data, callback, fail){
        $http.get(candidateDetailsURL+'?'+data).success(callback).error(fail);
    };

    this.deleteApplicationResource = function(data, callback, fail){
        var url = applicationDetails + '/' + data.applicationId + '/resource/' + data.fId + '/' + data.fKind;
        var ajaxOptions = {
            'ajaxtype': 'postDisposition',
            'url': url,
            'requestType': 'DELETE'
        };
        createRequestObject(null, callback, ajaxOptions,fail);
    };

    this.viewResource = function(data, params, callback, fail) {
        var url= resourceDetails+ '/' + data.applicationId + '/file/' + data.fId + '?' + params;
        var ajaxOptions = {
            'ajaxtype': 'viewResource',
            'url': url
        };
        createRequestObject(null, callback, ajaxOptions,fail);
    };

    this.viewOfferResource = function(appEId, fileEId, data, callback, fail){
        var url = resourceDetails+ '/' + appEId + '/offer/' + fileEId + '?' + data;
        var ajaxOptions = {
            'ajaxtype': 'viewOfferResource',
            'url': url
        };
        createRequestObject(null, callback, ajaxOptions,fail);
    };

    //POST message for MSG TO ALTERNATE
    this.postAlternateMsg = function(id, data, callback, fail){
        var url = applicationDetails+'/'+id+'/sendToAlternates';
        var ajaxOptions = {
            'ajaxtype': 'postAlternateMsg',
            'url': url,
            'requestType': 'POST'
        };
        data.headers = {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'};
        createRequestObject(data, callback, ajaxOptions,fail);
    };

    //GET message for MSG TO ALTERNATE
    this.getAlternateMsg = function(id, callback, fail){
        var url = applicationDetails+'/'+id+'/sendToAlternates';
        var ajaxOptions = {
            'ajaxtype': 'getAlternateMsg',
            'url': url
        };
        createRequestObject(null, callback, ajaxOptions,fail);
    };

    //GET register candidate for assessment
    this.registerCandAss = function(id, stateId, callback, fail){
        var url = applicationDetails+'/'+id+'/state/'+stateId+'/registerCandidateForAssessment';
        var ajaxOptions = {
            'ajaxtype': 'registerCandAss',
            'url': url
        };
        createRequestObject(null, callback, ajaxOptions,fail);
    };

    //GET : Save SHL asessment date
    this.saveShlAssessmentInviteDate = function(id, stateId, callback, fail){
        var url = applicationDetails+'/'+id+'/state/'+stateId+'/saveSHLAssessmentInvitationDate';
        var ajaxOptions = {
            'ajaxtype': 'saveShlAssessmentInviteDate',
            'url': url
        };
        createRequestObject(null, callback, ajaxOptions,fail);
    };

    //GET Invite/ ReInvite Candidate for Assessment
    this.inviteCandAssessment = function(id, stateId, callback, fail){
        var url = applicationDetails+'/'+id+'/state/'+stateId+'/inviteCandidateforAssessmentDetails';
        var ajaxOptions = {
            'ajaxtype': 'inviteCandAssessment',
            'url': url
        };
        createRequestObject(null, callback, ajaxOptions,fail);
    };

    //POST assessment language
    this.saveAssessmentLanguage = function(data, id, stateId, callback, fail){
        var url = applicationDetails+'/'+id+'/state/'+stateId+'/saveSHLAssessmentLanguage';
        var ajaxOptions = {
            'ajaxtype': 'saveAssessmentLanguage',
            'url': url,
            'requestType': 'POST'
        };
        data.headers = {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'};
        createRequestObject(data, callback, ajaxOptions,fail);
    };

    //GET assessment language list
    this.getAssessmentLanguages = function(id, stateId, callback, fail){
        var url = applicationDetails+'/'+id+'/state/'+stateId+'/getShlAssessmentLanguages';
        var ajaxOptions = {
            'ajaxtype': 'getAssessmentLanguages',
            'url': url
        };
        createRequestObject(null, callback, ajaxOptions,fail);
    };

    //GET to start background check
    this.getStartBckgrndCheck = function(id, stateId, callback, fail){
        var url = applicationDetails+'/'+id+'/state/'+stateId+'/startBackgroundCheck';
        var ajaxOptions = {
            'ajaxtype': 'getStartBckgrndCheck',
            'url': url
        };
        createRequestObject(null, callback, ajaxOptions,fail);
    };

    //GET Bckgrnd Report / Access report
    this.getBckgrndReport = function(id, stateId, callback, fail){
        var url = applicationDetails+'/'+id+'/state/'+stateId+'/accessBackgroundCheckReport';
        var ajaxOptions = {
            'ajaxtype': 'getBckgrndReport',
            'url': url
        };
        createRequestObject(null, callback, ajaxOptions,fail);
    };

    //POST details to remond approver
    this.postRemindApprover = function(id, data, callback, fail){
        var url = applicationDetails+'/'+id+'/resendOfferApproval';
        var ajaxOptions = {
            'ajaxtype': 'postRemindApprover',
            'url': url,
            'requestType': 'POST'
        };
        data.headers = {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'};
        createRequestObject(data, callback, ajaxOptions,fail);
    };

    //GET details to remind Approver
    this.getRemindApprover = function(id, callback, fail){
        var url = applicationDetails+'/'+id+'/resendOfferApproval';
        var ajaxOptions = {
            'ajaxtype': 'getRemindApprover',
            'url': url
        };
        createRequestObject(null, callback, ajaxOptions,fail);
    };

    //POST details to retract approver
    this.postRetractApprover = function(id, data, callback, fail){
        var url = applicationDetails+'/'+id+'/retract';
        var ajaxOptions = {
            'ajaxtype': 'postRetractApprover',
            'url': url,
            'requestType': 'POST'
        };
        data.headers = {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'};
        createRequestObject(data, callback, ajaxOptions,fail);
    };

    //GET details to retract approver
    this.getRetractApprover = function(id, callback, fail){
        var url = applicationDetails+'/'+id+'/retract';
        var ajaxOptions = {
            'ajaxtype': 'getRetractApprover',
            'url': url
        };
        createRequestObject(null, callback, ajaxOptions,fail);
    };

    //GET Candidate Application Form
    this.getCandApplicationForm = function(id, callback, fail){
        var url = applicationDetails+'/'+id+'/candidateApplicationForms';
        var ajaxOptions = {
            'ajaxtype': 'getCandApplicationForm' ,
            'url': url
        };
        createRequestObject(null, callback, ajaxOptions, fail);
    };

    //GET pre-Interview Forms
    this.getPreInterviewForms = function(id, stateId, callback){
        var url = applicationDetails+'/'+id+'/workflowState/'+stateId+'/preInterviewForms';
        var ajaxOptions = {
            'ajaxtype': 'getPreInterviewForms' ,
            'url': url
        };
        createRequestObject(null, callback, ajaxOptions);
    };

    //POST Upload offer Letter
    this.uploadOfferLetter = function(id, data, callback){
        var url = applicationDetails+'/'+id+'/uploadOffer';
        var ajaxOptions = {
            'ajaxtype': 'uploadOfferLetter',
            'url': url,
            'requestType': 'POST'
        };
        data.headers = {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'};
        createRequestObject(data, callback, ajaxOptions);
    };

    this.getMultipleOfferFormsFlag = function(callback){
        var url = applicationDetails+'/offers/permission';
        var ajaxOptions = {
            'ajaxtype': 'getmultipleOfferFormsFlag',
            'url': url
        };
        createRequestObject(null, callback, ajaxOptions);
    };

    this.getOfferForms = function(id, callback){
        var url = applicationDetails+'/'+id+'/offers';
        var ajaxOptions = {
            'ajaxtype': 'getOfferForms',
            'url': url
        };
        createRequestObject(null, callback, ajaxOptions);
    };

    this.userCanEditOfferForm = function(id, callback){
        var url = applicationDetails+'/'+id+'/editOfferForm';
        var ajaxOptions = {
            'ajaxtype': 'userCanEditOfferForm',
            'url': url
        };
        createRequestObject(null, callback, ajaxOptions);
    };

    //VIEW/GET Candidate Offer Form
    this.candOfferForm = function(data, callback){
        var url = applicationDetails+'/'+data.id+'/state/'+data.stateId;
        var ajaxOptions = {
            'ajaxtype': 'candOfferForm',
            'url': url
        };
        if (data.multipleOfferFormsEnabled) {
            var offerParam = data.eId ? '?offerFormEId=' + data.eId : '';
            data.edit ? ajaxOptions.url += '/offer' + offerParam : ajaxOptions.url += '/viewOffer';
        } else {
            data.edit ? ajaxOptions.url += '/offer' : ajaxOptions.url += '/viewOffer';
        }
        
        createRequestObject(null, callback, ajaxOptions);
    };

    //POST Candidate Offer form
    this.postCandOfferForm = function(id, stateId, offer, data, callback){
        var url = applicationDetails+'/'+id+'/state/'+stateId+'/offer?readMode=0';
        var ajaxOptions = {
            'ajaxtype': 'postCandOfferForm',
            'url': url,
            'requestType': 'POST'
        };
        offer.multipleOfferFormsEnabled ? ajaxOptions.url += '&offerFormEId=' + offer.id : '';
        data.headers = {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'};
        createRequestObject(data, callback, ajaxOptions);
    };

    //POST approve/reject/skip pending approval state
    this.offerAprroveActions = function(id, data, callback){
        var url = applicationDetails+'/'+id+'/approveOffer';
        var ajaxOptions = {
            'ajaxtype': 'offerAprroveActions',
            'url': url,
            'requestType': 'POST'
        };
        data.headers = { 'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8', 'Accept':'text/html, */*; q=0.01' };
        createRequestObject(data, callback, ajaxOptions);
    };

    //POST offer letter to approvers after selecting them
    this.sendOfferLetterReq = function(id, data, callback){
        var url = applicationDetails+'/'+id+'/offerApproval?readMode=0';
        var ajaxOptions = {
            'ajaxtype': 'offerAprroveActions',
            'url': url,
            'requestType': 'POST'
        };
        data.headers = { 'Content-Type':'application/json', 'Accept':'text/html, */*; q=0.01' };
        createRequestObject(data, callback, ajaxOptions);
    };

    //GET Select Approver Form Data
    this.getSelectApproverMessage = function(id, data, callback){
        var url;
        if(data){
            url = applicationDetails+'/'+id+'/offerApproval?'+data;
        }
        else
        {
            url = applicationDetails+'/'+id+'/offerApproval';
        }
        var ajaxOptions = {
            'ajaxtype': 'getSelectApproverMessage' ,
            'url': url
        };
        createRequestObject(null, callback, ajaxOptions);
    };

    //POST Approve/Reject candidate when submitted to HM
    this.candAppRejHM = function(id, data, callback){
        var url = applicationDetails+'/'+id+'/approveCandidate';
        var ajaxOptions = {
            'ajaxtype': 'candAppRejHM',
            'url': url,
            'requestType': 'POST'
        };
        data.headers = {'Content-Type':'application/json; charset=UTF-8'};
        createRequestObject(data, callback, ajaxOptions);
    };

    this.hasCompanySigner = function(id, templateId, callback, fail){
        var url = applicationDetails+'/'+id+'/offerLetterTemplate/'+templateId;
        var ajaxOptions = {
            'ajaxtype': 'hasCompanySigner' ,
            'url': url
        };
        createRequestObject(null, callback, ajaxOptions, fail);
    };

    //POST send offer letter
    this.sendESigOfferLetter = function(id, stateId, data, callback){
        var url = applicationDetails+'/'+id+'/state/'+stateId+'/sendESigOffer';
        var ajaxOptions = {
            'ajaxtype': 'sendESigOfferLetter',
            'url': url,
            'requestType': 'POST'
        };
        data.headers = {'Content-Type':'application/json; charset=UTF-8'};
        createRequestObject(data, callback, ajaxOptions);
    };

    this.voidESigOfferLetter = function(applicationId, data, callback){
        var url = applicationDetails + '/' + applicationId + '/offerLetter/void';
        var opts = {
            data: data || ''
        };
        var ajaxOptions = {
            'ajaxtype': 'voidESigOfferLetter',
            'url': url,
            'requestType': 'POST'
        };
        opts.passAsStringParam = true;
        opts.headers = {'Content-Type':'application/json; charset=UTF-8'};
        createRequestObject(opts, callback, ajaxOptions);
    };

    //POST send offer letter
    this.sendOfferLetter = function(id, stateId, data, callback){
        var url = applicationDetails+'/'+id+'/state/'+stateId+'/sendOffer';
        var ajaxOptions = {
            'ajaxtype': 'sendOfferLetter',
            'url': url,
            'requestType': 'POST'
        };
        data.headers = {'Content-Type':'application/json; charset=UTF-8'};
        createRequestObject(data, callback, ajaxOptions);
    };

    //send to Jobvite-Onboarding
    // Depricated not getting referenced anywhere
    this.sendToOnboarding = function(id, stateId, callback){
        $http({
            url: applicationDetails+'/'+id+'/state/'+stateId+'/onboarding',
            method : 'PUT',
            headers : {'Content-Type':'application/json; charset=UTF-8'}
        }).success(callback);
    };

    //stop Jobvite-Onboarding
    // Depricated not getting referenced anywhere
    this.retractJobviteOnboarding = function(id, stateId, newHireId, callback){
        $http({
            url: applicationDetails+'/'+id+'/state/'+stateId+'/onboarding/'+newHireId+'/retract',
            method : 'POST',
            headers : {'Content-Type':'application/json; charset=UTF-8'}
        }).success(callback);
    };

    //GET message template to send offer letter
    this.getOfferLetter = function(id, stateId, readMode, companySignerEId, callback){
        var url = applicationDetails+'/'+id+'/state/'+stateId+'/sendOffer?readMode='+readMode;
        if (companySignerEId != null) {
           url += '&companySignerEId=' + companySignerEId;
        }
        var ajaxOptions = {
            'ajaxtype': 'getOfferLetter' ,
            'url': url
        };
        createRequestObject(null, callback, ajaxOptions);
    };

    //GET Generate/Save Offer letter
    this.generateOfferLetter = function(id, offerLetterId, callback){
        var url = applicationDetails+'/'+id+'/offerLetter/'+offerLetterId+'?readMode=0';
        var ajaxOptions = {
            'ajaxtype': 'generateOfferLetter' ,
            'url': url
        };
        createRequestObject(null, callback, ajaxOptions);
    };

    //GET all offer letter templates
    this.getOfferLetterTemplates = function(id, stateId, callback){
        var url;
        if(stateId){
            url = applicationDetails+'/'+id+'/state/'+stateId+'/offerTemplates';
        }else{
            url = applicationDetails+'/'+id+'/viewOffer?readMode=0';
        }
        var ajaxOptions = {
            'ajaxtype': 'getOfferLetterTemplates' ,
            'url': url
        };
        createRequestObject(null, callback, ajaxOptions);
    };

    //GET Method to get rejected candidate's application
    this.viewApplications = function(id,readMode, callback){
        var url = applicationDetails+'/'+id+'/applications?'+readMode;
        var ajaxOptions = {
            'ajaxtype': 'viewApplications' ,
            'url': url
        };
        createRequestObject(null, callback, ajaxOptions);
    };

    //POST Method to reject candidate
    this.rejectCandidate = function(id, data, callback){
        var url = applicationDetails+'/'+id+'/reject';
        var ajaxOptions = {
            'ajaxtype': 'rejectCandidate',
            'url': url,
            'requestType': 'POST'
        };
        data.headers = {'Content-Type':'application/json; charset=UTF-8'};
        createRequestObject(data, callback, ajaxOptions);
    };

    //GET Method to reject candidate
    this.getRejectCandidateDetails = function(id, callback){
        var url = applicationDetails+'/'+id+'/reject';
        var ajaxOptions = {
            'ajaxtype': 'getRejectCandidateDetails' ,
            'url': url
        };
        createRequestObject(null, callback, ajaxOptions);
    };

    //GET Method to submit to HM
    // Depricated not getting referenced anywhere
    this.getSubmitToHM = function(id, stateId, callback){
        $http.get(applicationDetails+'/'+id+'/state/'+stateId+'/submitHM').success(callback);
    };

    //POST Method to submit to HM
    // Depricated not getting referenced anywhere
    this.postSubmitToHM = function(id, stateId, data, callback, fail){
        $http({
            url: applicationDetails+'/'+id+'/state/'+stateId+'/submitHM',
            data : data,
            method : 'POST',
            headers : {'Content-Type':'application/json; charset=UTF-8'}
        }).success(callback).error(fail);
    };

    //Method to get Workflow details
    this.getWorkflowDetails = function(id, stateId, callback){
        var url = applicationDetails+'/'+id+'/workflowState/'+stateId+'?_='+new Date().getTime();
        var ajaxOptions = {
            'ajaxtype': 'getWorkflowDetails' ,
            'url': url
        };
        createRequestObject(null, callback, ajaxOptions);
    };

    //Method to get Workflow Summary
    this.getWorkflowSummary = function(id, data, callback, fail){
        var url = applicationDetails+'/'+id+'/workflowSummary?_='+new Date().getTime()+'&'+data;
        var ajaxOptions = {
            'ajaxtype': 'getWorkflowSummary' ,
            'url': url
        };
        createRequestObject(null, callback, ajaxOptions, fail);
    };

    //Method to get FreeBusy List for a User
    this.freeBusy = function(userId, startDate, endDate, timezoneId, callback){
        var options = 'userId='+ userId + '&startDate=' + new moment(startDate).format('YYYY-MM-DDTHH:mm:ss') + '&endDate=' + new moment(endDate).format('YYYY-MM-DDTHH:mm:ss');
        if(timezoneId || timezoneId === 0){
            options += '&timezoneId='+timezoneId;
        }
        var url = calendarUrl+'/user/freebusyInfo?'+ options;
        var ajaxOptions = {
            'ajaxtype': 'freeBusy' ,
            'url': url
        };
        createRequestObject(null, callback, ajaxOptions);
    };
    this.freeBusyResource = function(resourceId, startDate, endDate, timezoneId, callback){
        var options = 'locationId='+ resourceId + '&startDate=' + new moment(startDate).format('YYYY-MM-DDTHH:mm:ss') + '&endDate=' + new moment(endDate).format('YYYY-MM-DDTHH:mm:ss');
        if(timezoneId || timezoneId === 0){
            options += '&timezoneId='+timezoneId;
        }
        var url = calendarUrl+'/conferenceRoom/freebusyInfo?'+ options;
        var ajaxOptions = {
            'ajaxtype': 'freeBusyResource',
            'url': url
        };
        createRequestObject(null, callback, ajaxOptions);
    };

    // Method to get FreeBusy/Googelcalendar events List for multiple users
    // TODO: merge this method with the one above.
    this.gCalEvents = function(userIds, startDate, endDate, timezoneId, callback){
        var options = $.param(userIds) + '&startDate=' + new moment(startDate).format('YYYY-MM-DDTHH:mm:ss') + '&endDate=' + new moment(endDate).format('YYYY-MM-DDTHH:mm:ss');
        if(timezoneId || timezoneId === 0){
            options += '&timezoneId='+timezoneId;
        }

        var ajaxOptions = {
            'ajaxtype': 'gCalEvents' ,
            'url': calendarUrl+'/user/freebusyInfo?'+ options
        };

        createRequestObject(null, callback, ajaxOptions);
    };

    this.gCalEventsResource = function(resourceIds, startDate, endDate, timezoneId, callback){
        var options = $.param(resourceIds) + '&startDate=' + new moment(startDate).format('YYYY-MM-DDTHH:mm:ss') + '&endDate=' + new moment(endDate).format('YYYY-MM-DDTHH:mm:ss');
        if(timezoneId || timezoneId === 0){
            options += '&timezoneId='+timezoneId;
        }

        var ajaxOptions = {
            'ajaxtype': 'gCalEventsResource' ,
            'url': calendarUrl+'/conferenceRoom/freebusyInfo?'+ options
        };

        createRequestObject(null, callback, ajaxOptions);
    };

    //Method to get Activity Feed
    this.getActivityFeed = function(id, count, offset, callback){
        var url = applicationDetails+'/'+id+'/activity?count='+count+'&offset='+offset;
        var ajaxOptions = {
            'ajaxtype': 'getActivityFeed' ,
            'url': url
        };
        createRequestObject(null, callback, ajaxOptions);
    };

    //Method for getting note count
    this.getNotesCount = function(appEId,data,callback) {
        var url = applicationDetails +'/' + appEId + '/note/count?' + $.param(data);
        var ajaxOptions = {
            'ajaxtype': 'getNotesCount' ,
            'url': url
        };
        createRequestObject(null, callback, ajaxOptions);
    };

    this.getEvaluationsCount = function(appEId,data,callback) {
        var url = applicationDetails +'/' + appEId + '/evaluations/count?'+ $.param(data);
        var ajaxOptions = {
            'ajaxtype': 'getEvaluationsCount' ,
            'url': url
        };
        createRequestObject(null, callback, ajaxOptions);
    };

    //Method for getting message count
    this.getMessagesCount = function(appEId,data,callback) {
        var url = applicationDetails + '/'+ appEId+ '/message/count?' + $.param(data);
        var ajaxOptions = {
            'ajaxtype': 'getMessagesCount' ,
            'url': url
        };
        createRequestObject(null, callback, ajaxOptions);
    };

    //Method for getting notes
    this.getNotes = function(appEId,data,callback) {
        var url= applicationDetails + '/'+ appEId+ '/notes?' + $.param(data);
        var ajaxOptions = {
            'ajaxtype': 'getNotes' ,
            'url': url
        };
        createRequestObject(null, callback, ajaxOptions);
    };

    //addNote
    this.addNote = function(appEId,data,callback){
        var url = applicationDetails + '/' + appEId + '/note' + '?readMode=0';
        var ajaxOptions = {
            'ajaxtype': 'addNote',
            'url': url,
            'requestType': 'POST'
        };
        data.noTransform = true;
        data.headers = {'Content-Type':'application/json; charset=UTF-8'};
        createRequestObject(data, callback, ajaxOptions);
    };

    //addTask
    this.addTask = function(args, callback){
        var ajaxOptions = {
            'ajaxtype': 'addTask',
            'url': saveTaskUrl,
            'requestType': 'POST'
        };
        var opts = {data: decodeURIComponent($.param(args))};
        opts.passAsStringParam = true;
        opts.noTransform = true;
        opts.headers = {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'};
        createRequestObject(opts, callback, ajaxOptions);
    };

    this.saveContact = function(contactId, data) {
        data.info = {
            infoObject: []
        };
        angular.forEach(data.details.info, function(value, key){
            data.info.infoObject.push(value);
        });
        delete data.details.info;
        return $http({
            url: jvUrls.source + '/action/person/contactDetailsPage',
            method: 'POST',
            cache: 'false',
            headers: { 'Content-Type':'application/x-www-form-urlencoded', 'Accept':'text/html, */*; q=0.01' },
            data: $.param({
                details: JSON.stringify(data),
                action: 'doSaveDetails',
                ids: contactId
            }, true)
        });
    };

    //update note
    this.updateNote = function(appEId, noteEId, data, callback){
        var url = applicationDetails + '/' + appEId + '/note/' + noteEId + '?readMode=0';
        var ajaxOptions = {
            'ajaxtype': 'updateNote',
            'url': url,
            'requestType': 'PUT'
        };
        data.headers = {'Content-Type':'application/json; charset=UTF-8'};
        createRequestObject(data, callback, ajaxOptions);
    };

    //delete note
    this.deleteNote = function(appEId,noteEId,callback) {
        var url = applicationDetails +'/' + appEId +'/note/' + noteEId;
        var ajaxOptions = {
            'ajaxtype': 'deleteNote',
            'url': url,
            'requestType': 'DELETE'
        };
        createRequestObject(null, callback, ajaxOptions);
    };

    //Method for getting message
    this.getMessages = function(appEId,data,callback) {
        var url= applicationDetails + '/' + appEId + '/messages?' + $.param(data);
        var ajaxOptions = {
            'ajaxtype': 'getMessages' ,
            'url': url
        };
        createRequestObject(null, callback, ajaxOptions);
    };

    //addMessage
    this.addMessage = function(appEId,args,callback) {
        var url = applicationDetails + '/' + appEId + '/message' + '?readMode=0';
        var ajaxOptions = {
            'ajaxtype': 'addMessage',
            'url': url,
            'requestType': 'POST'
        };
        var opts = {data: args};
        opts.passAsStringParam = true;
        opts.noTransform = true;
        opts.headers = {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'};
        createRequestObject(opts, callback, ajaxOptions);
    };

    //delete message
    this.deleteMessage = function(data,callback){
        var url= candidateDetailsURL+'?action=deleteMessage&'+$.param(data);
        var ajaxOptions = {
            'ajaxtype': 'deleteMessage' ,
            'url': url
        };
        createRequestObject(null, callback, ajaxOptions);
    };

    //messageTemplate data
    this.getMessageTmpl = function(appEId,data,callback){
        var url = applicationDetails + '/' + appEId + '/messageTemplates?';

        if (data.enableSMSMessaging) {
            url = applicationDetails + '/' + appEId + '/message/templates?';
            delete data.enableSMSMessaging;
        }

        var ajaxOptions = {
            'ajaxtype': 'getMessageTmpl',
            'url': url + $.param(data)
        };

        createRequestObject(null, callback, ajaxOptions);
    };

    this.getCanvasRecruiterDetails = function(data,callback) {
        var url= applicationDetails + '/sms/recruiter';
        var ajaxOptions = {
            'ajaxtype': 'getCanvasRecruiterDetails' ,
            'url': url
        };
        createRequestObject(null, callback, ajaxOptions);
    };

    this.addSms = function(appEId,args,callback) {
        var url= applicationDetails + '/' + appEId + '/sms' + '?readMode=0';
        var ajaxOptions = {
            'ajaxtype': 'addSms',
            'url': url,
            'requestType': 'POST'
        };
        var opts = {data: args};
        opts.passAsStringParam = true;
        opts.noTransform = true;
        opts.headers = {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'};
        createRequestObject(opts, callback, ajaxOptions);
    };

    this.getCustomMessageTemplate = function(applicationId, templateId, data) {
        return $http.get(applicationDetails + '/' + applicationId + '/userEmailTemplate/' + templateId, { params: data });
    };

    //noteTemplate data
    this.getNoteTmpl = function(appEId,data,callback){
        var url = applicationDetails + '/' + appEId + '/noteTemplates?';

        var ajaxOptions = {
            'ajaxtype': 'getNoteTmpl',
            'url': url + $.param(data)
        };

        createRequestObject(null, callback, ajaxOptions);
    };

    this.postCandDetailsEdit = function(data, applicationId, candidateEId, callback, fail){
        var url = applicationDetails+'/'+applicationId+'/editDetails';
        var ajaxOptions = {
            'ajaxtype': 'postCandDetailsEdit',
            'url': url,
            'requestType': 'POST'
        };
        data.headers = {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'};
        createRequestObject(data, callback, ajaxOptions, fail);
    };

    this.candDetailsEdit = function(applicationId, callback,fail){
        var url = applicationDetails + '/' + applicationId + '/editDetails';
        var ajaxOptions = {
            'ajaxtype': 'candDetailsEdit' ,
            'url': url
        };
        createRequestObject(null, callback, ajaxOptions, fail);
    };

    this.getFilteredData = function(data){
        var deferred = $q.defer();
        data.viewFields = data.viewFields.filter(function(field){
            return $.inArray(field.fieldId, [-15,-16,-61]) < 0;
        });
        deferred.resolve(data);
        return deferred.promise;
    };

    this.edit = function(applicationId, callback,fail) {
        var url = applicationDetails + '/' + applicationId + '/editAppDetails';
        var ajaxOptions = {
            'ajaxtype': 'editAppDetails',
            'url': url
        };
        createRequestObject(null, callback, ajaxOptions, fail);
    };

    this.update = function(applicationId, data,callback,fail) {
        var url = applicationDetails + '/' + applicationId + '/editAppDetails';
        var ajaxOptions = {
            'ajaxtype': 'editUpdateAppDetails',
            'url': url,
            'requestType': 'POST'
        };
        data.headers = {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'};
        createRequestObject(data, callback, ajaxOptions, fail);
    };

    this.updateWorkflowActions = function(applicationId, data, callback, fail){
        var url = applicationDetails+'/'+applicationId+'/workflowActions';
        var ajaxOptions = {
            'ajaxtype': 'updateWorkflowActions',
            'url': url,
            'requestType': 'POST'
        };
        data.headers = {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'};
        createRequestObject(data, callback, ajaxOptions, fail);
    };

    this.getApplicationDetails = function(applicationId, data, callback) {
        paging.index = paging.list.indexOf(applicationId);

        var ajaxOptions = {
            'ajaxtype': 'getApplicationDetails' ,
            'url': applicationDetails + '/' + applicationId + '/details?_='+new Date().getTime()+'&'+data
        };

        createRequestObject(null, callback, ajaxOptions);
    };

    this.markApplicationAsViewed = function(applicationId,callback){
        var url = applicationDetails + '/' + applicationId + '/view?readMode=0';
        var ajaxOptions = {
            'ajaxtype': 'markApplicationAsViewed',
            'url': url,
            'requestType': 'PUT'
        };
        createRequestObject(null, callback, ajaxOptions);
    };

    this.getAppFieldDetails = function(applicationId, readMode, callback,fail){
        //VBTODO: use append to hashbang method. Naming convention of this and the above
        var url = applicationDetails + '/' + applicationId + '/appDetails?'+readMode;
        var ajaxOptions = {
            'ajaxtype': 'getAppFieldDetails',
            'url': url
        };
        createRequestObject(null, callback, ajaxOptions, fail);
    };

    this.collections = function(applicationId, readMode, callback){
        //VBTODO: use append to hashbang method. Naming convention of this and the above
        var url = applicationDetails + '/' + applicationId + '/collection';
        if(readMode && readMode === '0'){
            url+='?readMode=0';
        }
        var ajaxOptions = {
            'ajaxtype': 'collections',
            'url': url
        };
        createRequestObject(null, callback, ajaxOptions);
    };

    this.addExistingCollection = function(applicationId, data, readMode, callback){
        //VBTODO: use append to hashbang method. Naming convention of this and the above
        var url = applicationDetails + '/' + applicationId + '/collection' +'?eid=' + data.eid+'&readMode='+readMode;
        var ajaxOptions = {
            'ajaxtype': 'addExistingCollection',
            'url': url,
            'requestType': 'PUT'
        };
        createRequestObject(null, callback, ajaxOptions);
    };

    this.addNewCollection = function(applicationId, data, readMode, callback){
        //VBTODO: use append to hashbang method. Naming convention of this and the above
        var url = applicationDetails + '/' + applicationId + '/collection' +'?name=' + encodeURIComponent(data.name)+'&readMode='+readMode;
        var ajaxOptions = {
            'ajaxtype': 'addNewCollection',
            'url': url,
            'requestType': 'PUT'
        };
        createRequestObject(null, callback, ajaxOptions);
    };

    this.deleteCollection = function(applicationId, data, callback){
        //VBTODO: use append to hashbang method. Naming convention of this and the above
        var url = applicationDetails + '/' + applicationId + '/collection/' + data.eid;
        var ajaxOptions = {
            'ajaxtype': 'deleteCollection',
            'url': url,
            'requestType': 'DELETE'
        };
        createRequestObject(null, callback, ajaxOptions);
    };

    this.appSources = function(applicationId, readMode, callback){
        var url = applicationDetails + '/' + applicationId + '/applicationSources';
        if(readMode && readMode === '0'){
            url+='?readMode=0';
        }
        var ajaxOptions = {
            'ajaxtype': 'appSources',
            'url': url
        };
        createRequestObject(null, callback, ajaxOptions);
    };

    this.appSourceTypes = function(callback){
        var ajaxOptions = {
            'ajaxtype': 'getAppSourceTypes' ,
            'url': applicationDetails + '/sourceTypes'
        };
        createRequestObject(null, callback, ajaxOptions);
    };

    this.getEmployee = function(employeeId, callback, fieldId){
        var ajaxOptions = {
            'ajaxtype': 'getEmployee'
        };
        if(fieldId) {
            ajaxOptions['url'] = userInfoUrl+'/search?action=getEmployees&ids=' + employeeId + '&fieldId=' + fieldId;
        } else {
            ajaxOptions['url'] = userInfoUrl+'/search?action=getEmployees&ids=' + employeeId;
        }
        createRequestObject(null, callback, ajaxOptions);
    };

    this.updateAppSource = function(applicationId, data, callback){
        var url = applicationDetails + '/' + applicationId + '/source?' + $.param(data);
        var ajaxOptions = {
            'ajaxtype': 'updateAppSource',
            'url': url,
            'requestType': 'POST'
        };
        createRequestObject(null, callback, ajaxOptions);
    };

    // Depricated not getting reffered
    this.downloadFile = function(data,callback){
        $http.get(resourceDetails+'?action=downloadResource&'+data).success(callback);
    };

    // Depricated not getting reffered
    this.header = function(applicationId, callback) {
        $http.get(candidateDetailsURL + '?applicationId=' + applicationId).success(callback);
    };

    this.quickView = function(id, callback) {
        if (quickViews[id]) {
            callback(quickViews[id]);
            return;
        }
        var options = {
            'ajaxtype': 'getReqQuickView' ,
            'url': reqListRestBaseUrl + '/' + id + '/quickView'
        };

        createRequestObject(null, function(response){
            quickViews[id] = response;
            callback(response);
        }, options);
    };

    this.employeeSearch = function() {
        var url = userInfoUrl + '/search?';
        var pageSize = 50;

        var config = {
            id: 'EId',
            ajax: {
                url: url,
                quietMillis: 100,
                data: function(term, page) {
                    pageSize = term && 10 || 50;
                    return {
                        q: term,
                        pageSize: pageSize,
                        page: page - 1,
                        fetchMaxSize: true
                    };
                },
                results: function(data, page) { // parse the results into the format expected by Select2.
                    // since we are using custom formatting functions we do not need to alter remote JSON data
                    var more = (pageSize * page) < data.employeesCount;
                    return {
                        results: data.employees,
                        more: more
                    };
                }
            },
            formatResult: function(employee) {
                return '<strong>' + TextUtil.htmlEncode(employee.fullName) + '</strong>' + employee.email;
            },
            formatSelection: function(employee) {
                return employee.fullName;
            },
            initSelection: function(element, callback) {
                var url = config.ajax.url,
                    isMultiple = element.attr('multiple');
                if (isMultiple) {
                    url += '&ids=' + element.val();
                } else {
                    url += '&ids=' + element.val().split(',').join('&ids=');
                }

                $.ajax({
                    type: 'GET',
                    url: url,
                    success: function(data) {
                        data = config.ajax.results(data).results;
                        if (!isMultiple) {
                            if (data.length) {
                                data = data[0];
                            } else {
                                data = false;
                            }
                        }
                        callback(data);
                    }
                });
            }
        };
        return config;
    };

    this.employeeSelect = function(params){
        var url = userInfoUrl+'/search?';
        //var url = '../../action/requisitionDetails?action=getEmployees';
        var pageSize = 50;
        var config = {
            id:'EId',
            ajax : {
                url : url,
                quietMillis: 100,
                data : function (term, page) {
                    pageSize = term && 10 || 50;
                    var result = {
                        q: term,
                        pageSize: pageSize,
                        page: page - 1,
                        fetchMaxSize: true
                    };
                    if(angular.isFunction(params)){
                        angular.extend(result, params());
                    }else if(angular.isObject(params)){
                        angular.extend(result, params);
                    }
                    return result;
                },
                results: function (data, page) { // parse the results into the format expected by Select2.
                    // since we are using custom formatting functions we do not need to alter remote JSON data
                    var more = (pageSize * page) < data.employeesCount;
                    return {
                        results: data.employees,
                        more: more
                    };
                }
            },
            formatResult: function (employee) {
                return '<strong>' + TextUtil.htmlEncode(employee.fullName) + '</strong> ' + employee.email;
            },
            formatSelection: function (employee) {
                if(employee.fullName){
                    return employee.fullName;
                }else{
                    return (employee.firstName || '') +' '+ (employee.lastName || '');
                }
            },
            initSelection: function(element, callback) {
                //making sure we dont make employee select call without valid user ids.

                    var url = config.ajax.url,
                    isMultiple = element.attr('multiple');
                    if (isMultiple) {
                        url += '&ids=' + element.val();
                    } else {
                        url += '&ids=' + element.val().split(',').join('&ids=');
                    }

                    $.ajax({ type: 'GET', url: url, success: function(data){
                        data = config.ajax.results(data).results;
                        if (!isMultiple) {
                            if (data.length) {
                                data = data[0];
                            } else {
                                data = false;
                            }
                        }
                        callback(data);
                    }});

            }
        };
        return config;
    };

    this.locationMultiSelect = function(requisition){
            var url = '../../action/requisition/' + requisition + '/locations';
            var pageSize = 50;
            var config = {
               id:'EId',
              ajax : {
                   url: function () {
                      return url;
                   },
                   quietMillis: 100,
                   data : function (term, page) {
                        pageSize = term && 10 || 50;
                        var result = {
                            name: term,
                            pageSize: pageSize,
                            page: page - 1,
                            fetchMaxSize: true
                        };
                       return result;
                   },
                   results: function (data, page) { // parse the results into the format expected by Select2.
                       // since we are using custom formatting functions we do not need to alter remote JSON data
                       var more = Boolean(pageSize <= (data && data.locations && data.locations.length));
                       return {
                           results: data.locations,
                           more: more
                      };
                  }
              },
                formatResult: function (location) {
                    return TextUtil.htmlEncode(location.name);
                },
                formatSelection: function (location) {
                    return location.name;
               },
                initSelection: function(element, callback) {
                  var url = '/admin/action/admin/location',
                  isMultiple = element.attr('multiple');
                  if (isMultiple) {
                      url += '?&ids=' + element.val();
                   } else {
                             url += '?&ids=' + element.val().split(',').join('&ids=');
                   }

                   $.ajax({ type: 'GET', url: url, success: function(data){
                      data = config.ajax.results(data).results;
                       if (!isMultiple) {
                           if (data.length) {
                               data = data[0];
                           } else {
                               data = false;
                           }
                      }
                      callback(data);
                   }});
               }
           };
          return config;
    };

    this.candidateSelect = function(jobId){
        var url = '../../action/requisitionDetails?action=getJobActiveCandidates';
        if (jobId) {
            url += '&j=' + jobId;
        }
        var config = {
            id:'eid',
            ajax : {
                url : url,
                data : function (term, page) {
                    var pageSize = term && 10 || 50;
                    return {
                        q: term,
                        pageSize: pageSize,
                        page: page - 1
                    };
                },
                results: function (data, page) { // parse the results into the format expected by Select2.
                    // since we are using custom formatting functions we do not need to alter remote JSON data
                    var more = Boolean(data.resultList.length);
                    return {
                        results: data.resultList,
                        more: more
                    };
                }
            },
            formatResult: function (employee) {
                return '<strong>' + TextUtil.htmlEncode(employee.firstName +' '+ employee.lastName) + '</strong> ' + employee.email;
            },
            formatSelection: function (employee) {
                return employee.firstName + employee.lastName;
            },
            initSelection: function(element, callback) {
                var url = config.ajax.url,
                    isMultiple = element.attr('multiple');
                if (isMultiple) {
                    url += '&ids=' + element.val();
                } else {
                    url += '&ids=' + element.val().split(',').join('&ids=');
                }

                $.ajax({ type: 'GET', url: url, success: function(data){
                    data = config.ajax.results(data).results;
                    if (!isMultiple) {
                        if (data.length) {
                            data = data[0];
                        } else {
                            data = false;
                        }
                    }
                    callback(data);
                }});
            }
        };
        return config;
    };

    this.interviewersSelect = function(id,stateId){

        var url = '../../action/application/'+id+'/interview/'+stateId+'/interviewers';
        var config = {
            id:'EId',
            ajax : {
                url : url,
                contentType : 'application/x-www-form-urlencoded',
                data : function (term, page) {
                    var pageSize = term && 10 || 50;
                    return {
                        q: term,
                        pageSize: pageSize,
                        page: page - 1
                    };
                },
                results: function (data, page) { // parse the results into the format expected by Select2.
                    // since we are using custom formatting functions we do not need to alter remote JSON data
                    var more = data.user.length === 10;
                    return {
                        results: data.user,
                        more: more
                    };
                }
            },
            formatResult: function (user) {
                return '<strong>' + TextUtil.htmlEncode(user.fullName) + '</strong>' + user.email;
            },
            formatSelection: function (user) {
                return user.fullName;
            },
            initSelection: function(element, callback) {
                var url = config.ajax.url,
                isMultiple = element.attr('multiple');

                if(element.val()){
                    element[0].value = element.val().replace(new RegExp('([[object Object]*],)','g'), '');
                }

                if (isMultiple) {
                    url += '?ids=' + element.val();
                } else {
                    url += '?ids=' + element.val().split(',').join('&ids=');
                }

                $.ajax({ type: 'GET', url: url, success: function(data){
                    data = config.ajax.results(data).results;
                    if (!isMultiple) {
                        if (data.length) {
                            data = data[0];
                        } else {
                            data = false;
                        }
                    }
                    callback(data);
                }});
            }
        };
        return config;
    };

    // Depricated not getting reffered
    this.getCandInfo = function(params, callback) {
        $http.get('../../action/application/addCandidate?' + params).success(callback);
    };

    // Depricated not getting reffered
    this.getReqsList = function(params,callback) {
        $http.get('../../action/requisitions?'+params).success(callback);
    };

    this.getReqDetails = function(params, callback){
        var ajaxOptions = {
            'ajaxtype': 'getReqDetails',
            'url': jvUrls.jhire+'/action/requisitionDetails?'+params
        };

        createRequestObject(null, callback, ajaxOptions);
    };

    // Depricated not getting reffered
    this.refreshReqsModal = function(params,callback) {
        $http.get('../../action/requisitionList?'+params).success(callback);
    };

    this.getContactId = function(params, callback, error) {
        var ajaxOptions = {
            'ajaxtype': 'getContactId',
            'url': jvUrls.source+'/action/person/contactDetailsPage?action=getOrCreateContacts&candidateEid='+params
        };

        createRequestObject(null, callback, ajaxOptions, error);
    };

    this.addCandidate = function(postData, postURL, callback){
        var ajaxOptions = {
            'ajaxtype': 'addCandidate' ,
            'url': postURL,
            'requestType': 'POST'
        };
        postData.serializeObject = true;
        createRequestObject(postData, callback, ajaxOptions);
    };

    // Depricated not getting reffered
    this.addCandToRequisitions = function(params, callback){
        var url='../../action/application/addCandidate';
        $http({
            url:url,
            data : params,
            method : 'POST',
            headers : {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'}
        }).success(callback);
    };

    this.parseResumeContent= function(params,callback,parseURL){
        var ajaxOptions = {
            'ajaxtype': 'parseResumeContent',
            'url': parseURL,
            'requestType': 'POST',
            'headers': {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'}
        };
        createRequestObject(params, callback, ajaxOptions);
    };

    // Depricated not getting reffered
    this.saveCandidate = function(params,callback) {
        var postData = this.serialize(params.result);
        var url='../../action/application/addCandidate?contactIds='+params.contactId+'&j='+params.jobIds.join(',')+'&clIds='+params.clIds+'&attIds='+params.attIds+'&sendEmail='+params.sendEmail+'&generalApplication='+params.generalApplication;
        if(params.appId)
            {url+='&appId=' + params.appId;}
        $http({
            url:url,
            data : postData,
            method : 'POST',
            headers : {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'}
        }).success(callback);
    };

    this.serialize = function(data){
        var checkBoxes = data.CheckBox, checkBoxResult =[], fileContentResult = [], employees = data.Array, employeesResult = [];
        var file = data.content;
        angular.forEach(checkBoxes, function(checkBoxValues, eId){
            angular.forEach(checkBoxValues, function(cbValue, cbKey){
                if(cbValue){
                    checkBoxResult.push({'name': eId, 'value': cbKey});
                }else{
                    checkBoxResult.push({'name': eId, 'value': ''});
                }
            });
        });

        angular.forEach(file, function(fileValues, fileContent){
            if(fileValues && angular.isArray(fileValues)){
                angular.forEach(fileValues, function(fileValue){
                    if(fileValue){
                        fileContentResult.push({'name': content, 'value': filValue});
                    }
                });
            }
        });

        angular.forEach(employees, function(employeeValues, eid){
            if(employeeValues && angular.isArray(employeeValues)){
                angular.forEach(employeeValues, function(cbValue){
                    if(cbValue){
                        employeesResult.push({'name': eid, 'value': cbValue});
                    }
                });
            }
        });

        data.CheckBox ={};
        data.Array = {};
        return $.param(data)+'&'+$.param(checkBoxResult) + '&' + $.param(employeesResult)+ '&' + $.param(fileContentResult);
    };


    this.getTemplate = function(params,mode,callback){
        var url='../../action/application/'+params.applicationId+'/interview/'+params.interviewTypeId+'/'+mode + '?';
        if(params.groupId)
            {url+='&groupId='+params.groupId;}
        if(params.readMode) {
            url += '&readMode=0';
        }
        var ajaxOptions = {
            'ajaxtype': 'getTemplate' ,
            'url': url
        };
        createRequestObject(null, callback, ajaxOptions);
    };

    this.sendMessage = function(postData,params,mode,callback){
        var url='../../action/application/'+params.applicationId+'/interview/'+params.interviewTypeId+'/'+mode;
        var ajaxOptions = {
            'ajaxtype': 'sendMessage',
            'url': url,
            'requestType': 'POST'
        };
        postData.headers = {'Content-Type':'application/json; charset=UTF-8'};
        createRequestObject(postData, callback, ajaxOptions);
    };

    // Getting interviewers for workflow tab
    this.getInterviewers = function(params, callback){
        var url = '../../action/application/'+params.applicationId+'/interview/'+params.interviewTypeId+'/interviewers';
        var ajaxOptions = {
            'ajaxtype': 'getInterviewers' ,
            'url': url
        };
        createRequestObject(null, callback, ajaxOptions);
    };

    // Fetches the url for the user's profile pic.
    // DONOTUSE: This will be removed soon.
    this.userProperty = function(params,callback, error){
        if(params.eid){
            var url = userInfoUrl +'/' + params.eid+'/property';
            if(params.property){
                url = url + '/' + params.property;
            }
        var ajaxOptions = {
            'ajaxtype': 'userProperty' ,
            'url': url
        };
        createRequestObject(null, callback, ajaxOptions, error);
        }
    };


    // TODO: merge this with the mothod above.
    this.propForUsers = function(propName, userIds, callback, error){
        var url = userInfoUrl + '/search/property/' + propName +'?userIds='+userIds.join();
        var ajaxOptions = {
            'ajaxtype': 'propForUsers' ,
            'url': url
        };
        createRequestObject(null, callback, ajaxOptions, error);
    };

    this.fetchSocialProfiles = function(contactID){
        // insert the script to begin the JSONP call.
        var script = document.createElement('script');
        script.src = jvUrls.source + '/action/crm/social?callback=setSocialProfiles&c=' + contactID;
        script.type = 'text/javascript';
        document.getElementsByTagName('head')[0].appendChild(script); // jquery doesn't keep the script appended,
                                                                    // but rather deletes it after its been called. This preserves the entity
    };

    /*
     * This call ets more than interview locations, it gets the message template items etc for
     * scheduling the itnerview. This is as per the BE contract in the wiki for Sprint 3 - get interviewer locations
     *
     */
    this.interviewLocations = function(applicationId, stateId,groupId, callback){
        var url= jvUrls.jhire+'/action/application/'+applicationId+'/interview/'+stateId+'/schedule';
        if(groupId) {
            url+='?groupId='+groupId;
        }
        var ajaxOptions = {
            'ajaxtype': 'interviewLocations' ,
            'url': url
        };
        createRequestObject(null, callback, ajaxOptions);
    };

    this.getSchedule = function(applicationId, stateId, params, callback){
        var ajaxOptions = {
            'ajaxtype': 'getSchedule' ,
            'url': jvUrls.jhire+'/action/application/'+applicationId+'/interview/'+stateId+'/schedule'
        };

        createRequestObject(params, callback, ajaxOptions);
    };

    this.interview = function(applicationId, stateId, postData, callback){
       /* $http({url: '../../action/application/'+applicationId+'/interview/'+stateId+'/schedule',
           method: 'POST',
           data:$.param(postData),
           headers : {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'}
           }).success(callback);*/

        $http({
            url: '../../action/application/'+applicationId+'/interview/'+stateId+'/schedule',
            method: 'POST',
            headers: { 'Content-Type':'application/x-www-form-urlencoded', 'Accept':'text/html, */*; q=0.01' },
            data: $.param({
            'schedule': JSON.stringify(postData)
            }, true)
        });
    };

    // Getting hired candidates edit form
    // Depricated not getting reffered
    this.getCandEditHireForm = function(params, callback){
        $http({
            url:'../../action/application/'+params.appEId+'/state/'+params.stateEId+'/editHireInfo',
            method :'GET',
            headers : {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'}
        }).success(callback);
    };
    // Save hired candidates edit form
    // Depricated not getting reffered
    this.savecandEditHireForm = function(params, postData,callback){
        $http({
            url:'../../action/application/'+params.appEId+'/state/'+params.stateEId+'/editHireInfo',
            method :'POST',
            data:$.param({
              'addHireRequest': postData
         }),
            headers : {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'}
        }).success(callback);
    };

    //Fetch social Profile
    this.fetchSocialProfile = function(params,callback){
        var url = applicationDetails+'/'+params.applicationId+'/socialProfile';
        var ajaxOptions = {
            'ajaxtype': 'fetchSocialProfile' ,
            'url': url
        };
        createRequestObject(null, callback, ajaxOptions);
    };

    //GET RedCarpet OnBoarding
    this.getStartOnBoardingRC = function(id, stateId, callback, fail){
        var url = applicationDetails+'/'+id+'/state/'+stateId+'/startOnBoardingAction';
        var ajaxOptions = {
            'ajaxtype': 'getStartOnBoardingRC' ,
            'url': url
        };
        createRequestObject(null, callback, ajaxOptions, fail);
    };

    //GET TalentWise OnBoarding
    this.getStartOnBoarding = function(id, stateId, callback, fail){
        var url = applicationDetails+'/'+id+'/state/'+stateId+'/startOnBoarding';
        var ajaxOptions = {
            'ajaxtype': 'getStartOnBoarding' ,
            'url': url
        };
        createRequestObject(null, callback, ajaxOptions, fail);
    };

    //GET TalentWise OnBoarding Report
    // Depricated not getting reffered
    this.getOnBoardingReport = function(id, stateId, callback, fail){
        $http.get(applicationDetails+'/'+id+'/state/'+stateId+'/accessOnBoardingReport').success(callback).error(fail);
    };

    // Get Candidate file like resumes, cover letter etc
    this.getCandFiles = function(appEId, fail,callback){
        var ajaxOptions = {
            'ajaxtype': 'getCandFiles',
            'url': applicationDetails +'/'+appEId+'/resources'
        };

        createRequestObject(null, callback, ajaxOptions, fail);
    };

    //GET to start background check
    this.getstartBackgroundCheckHR = function(id, stateId, callback, fail){
        var url = applicationDetails+'/'+id+'/state/'+stateId+'/startBackgroundCheck';
        var ajaxOptions = {
            'ajaxtype': 'getstartBackgroundCheckHR' ,
            'url': url
        };
        createRequestObject(null, callback, ajaxOptions, fail);
    };

    //GET Bckgrnd Report / Access report
    this.getBackgroundHRReport = function(id, stateId, callback, fail){
        var url = applicationDetails+'/'+id+'/state/'+stateId+'/accessBackgroundCheckReport';
        var ajaxOptions = {
            'ajaxtype': 'getBackgroundHRReport' ,
            'url': url
        };
        createRequestObject(null, callback, ajaxOptions, fail);
    };
    this.getCompanyLogo = function(callback,fail) {// doesnt work for localhost:8080
        var ajaxOptions = {
            'ajaxtype': 'getCompanyLogo' ,
            'url': adminActionUrl+'/company/profileLogo?imageType=Company'
        };
        createRequestObject(null, callback, ajaxOptions, fail);
    };

    /*POST PreOfferData
     *
     * postData contains {to, subject, content, forms}
     */
    this.savePreOfferData = function(appEId, stateEId, postData, callback){
        if(appEId && stateEId && postData){
        var url='../../action/application/'+ appEId +'/state/'+ stateEId +'/ofccpPreOffer';
        var ajaxOptions = {
            'ajaxtype': 'savePreOfferData',
            'url': url,
            'requestType': 'POST'
        };
        postData.headers = {'Content-Type':'application/json; charset=UTF-8'};
        createRequestObject(postData, callback, ajaxOptions);
        }
    };

    /*POST PostOfferData
     *
     * postData contains {to, subject, content, forms}
     */
    this.savePostOfferData = function(appEId, stateEId, postData, callback){
        if(appEId && stateEId && postData){
            var url= '../../action/application/'+ appEId +'/state/'+ stateEId +'/ofccpPostOffer';
            var ajaxOptions = {
                'ajaxtype': 'savePostOfferData',
                'url': url,
                'requestType': 'POST'
            };
            postData.headers = {'Content-Type':'application/json; charset=UTF-8'};
            createRequestObject(postData, callback, ajaxOptions);
        }
    };

    /*
     * Update OFCCP status pre / post
     */
    this.updateOfccpStatus = function(appEId, stateEId, callback){
        if(appEId && stateEId){
            var url= '../../action/application/'+ appEId +'/state/'+ stateEId +'/updateOfccpStatus';
            var ajaxOptions = {
                'ajaxtype': 'updateOfccpStatus',
                'url': url,
                'requestType': 'POST'
            };
            createRequestObject(null, callback, ajaxOptions);
        }
    };
    //GET PreOfferData
    this.getPreOfferData = function(id, stateId, callback, fail){
        if(id && stateId){
            var url = applicationDetails+'/'+ id +'/state/'+ stateId +'/ofccpPreOffer';
            var ajaxOptions = {
                'ajaxtype': 'getPreOfferData' ,
                'url': url
            };
            createRequestObject(null, callback, ajaxOptions, fail);
        }
    };

    //GET PostOfferData
    this.getPostOfferData = function(id, stateId, callback, fail){
        if(id && stateId){
            var url = applicationDetails+'/'+ id +'/state/'+ stateId +'/ofccpPostOffer';
            var ajaxOptions = {
                'ajaxtype': 'getPostOfferData' ,
                'url': url
            };
            createRequestObject(null, callback, ajaxOptions, fail);
        }
    };

    // Depricated not getting reffered - moved to candidateService
    this.moveCandidate = function(postData, callback){
        if(postData){
            $http({
                url: applicationList+'/'+ postData.destinationJobId +'/move/'+ postData.sourceJobId,
                method: 'POST',
                data: postData.data,
                headers: {'Content-Type':'application/json; charset=UTF-8'}
            }).success(callback);
        }
    };

    // Depricated not getting reffered - moved to candidateService
    this.deleteCandidate = function(applicationIds,callback){
        $http({
            url : applicationDetails+'/list',
            data : applicationIds,
            method: 'DELETE',
            headers: {'Content-Type':'application/json; charset=UTF-8'}
        }).success(callback);
    };

    this.getRequistionFilters = function(callback, fail) {
        var ajaxOptions = {
            'ajaxtype': 'getRequisitionFilters' ,
            'url': jvUrls.jhire + '/action/requisitions/filters?'
        };

        createRequestObject(null, callback, ajaxOptions, fail);
    };

    this.setUserTimezoneObject = function(timezoneObj){
        userTimezoneObj = timezoneObj;
    };

    this.getUserTimezoneObject = function(){
        return userTimezoneObj;
    };

    //POST details to reject offer with selected disposition (workflow change)
    // Depricated not getting reffered
    this.postOfferRejectDisposition = function(id, stateEId, offerDisposition, callback, fail){
        $http({
            url: applicationDetails+'/'+id+'/offerreject'+'/'+stateEId+'/'+offerDisposition,
            method : 'POST',
            headers : {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'}
        }).success(callback).error(fail);
    };

     /**
     * @method requestCandidateAvailability
     * @description Makes the availability request call to the service, with the payload data
     * @param {string} stateEId The workflow state EID
     * @param {object} payload The payload data which needs to be passed to the service
     * @param {callback} success The success callback method
     * @param {callback} fail The fail callback method
     * @returns {method} Returns the success or failure callback method based on the service request
     */
    this.requestCandidateAvailability = function(stateEId, payload, callback, fail) {
        var ajaxOptions = {
            'ajaxtype': 'postRequestCandidateAvailability' ,
            'url': interviewUrl+'/'+stateEId+'/requestAvailability',
            'requestType': 'POST'
        };

        payload.headers = {'Content-Type':'application/json; charset=UTF-8'};

        createRequestObject(payload, callback, ajaxOptions, fail);

    };
    this.saveUploadContent =function(data, fileIds, uploadParams, callback, fail) {
        var ajaxOptions = {
            'ajaxtype': 'saveUploadContent',
            'url': '../../action/application/' + data.applicationId + '/resource/' + fileIds+ '/' + data.kind,
            'requestType': 'POST',
            'params': $.param(uploadParams)
        };
        data.headers = {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'};
        createRequestObject(data, callback, ajaxOptions, fail);
    };
    this.fetchClickedAttachment =function(appId, fileId, callback) {
        var ajaxOptions = {
            'ajaxtype': 'fetchClickedAttachment',
            'url': '../../action/resource/' + appId + '/attachment/' + fileId
        };
        createRequestObject(null, callback, ajaxOptions);
    };
    this.getPhoneNoList = function(args, callback) {
        var options = {
            'ajaxtype': 'phoneList',
            'url': phoneListUrl,
            'requestType': 'GET'
        };
        args.headers = {'Content-Type': 'application/json; charset=UTF-8'};
        createRequestObject(args, callback, options);
    };
}]);
